export function DevScreenshotUplodaer(props: {
  kind: string;
  ident: string;
  name: string;
}) {
  if (!DEV) {
    return null;
  }

  return (
    <div>
      <label>
        <input
          style={{ width: 0, height: 0 }}
          type="file"
          onChange={(e) => {
            const fd = new FormData();
            fd.append("kind", props.kind);
            fd.append("id", props.ident);
            fd.append("name", props.name);
            fd.append("file", e.target.files?.[0] ?? "no file");
            fetch("/upload-image", {
              method: "post",
              body: fd,
            });
          }}
        />
        <div style={{ background: "green", color: "white", padding: 5 }}>
          Upload image
        </div>
      </label>
    </div>
  );
}
